<it-modal #graphModal="itModal" size="xl" (showEvent)="createSvg()">
	<ng-container modalTitle>{{ dossier.title }}</ng-container>
	<it-checkbox
		[(ngModel)]="showOnlyLatestExpression"
		[label]="'iterlex.show-only-latest-version' | translate"
		toggle="true"
		inline="true"
		(click)="createSvg()"
	></it-checkbox>
	<figure id="tree"></figure>
	<ng-container footer><span></span></ng-container>
</it-modal>
